<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      © کپی رایت {{ new Date().getFullYear() }}
      <b-link class="ml-25" href="#" target="_blank">
        آکادمی امیر امینی
      </b-link>
      <span class="d-none d-sm-inline-block ml-1">
        قدرت گرفته از سامانه آموزشی نیاز
      </span>
    </span>
    <!-- <span class="float-md-right d-none d-md-block"
      >Design & Develop With
      <feather-icon
        icon="HeartIcon"
        size="21"
        class="text-danger stroke-current"
      />Moein Ertebat Pooya.co
    </span> -->
  </p>
</template>

<script>
import { BLink } from "bootstrap-vue";

export default {
  components: {
    BLink,
  },
};
</script>
